import React, {useContext} from "react";
import {Farm} from "../../../contexts/Farms/types";
import useUnstake from "../../../hooks/useUnstake";
import useModal from "../../../hooks/useModal";
import WithdrawModal from "../../Farm/components/WithdrawModal";
import Button from "../../../components/Button";
import BigNumber from "bignumber.js";
import useReward from "../../../hooks/useReward";
import {FarmContext} from "../../../contexts/farm_provider/farm_provider";
import styled, {ThemeContext} from "styled-components";
import {ButtonProps, StyledButtonProps} from "../../../components/Button/Button";
import {useWallet} from "use-wallet";
import {UserAccoutContext} from "../../../contexts/farm_provider/user_account_provider";


export const Reward: React.FC = () => {
    const {ethAmout} = useContext(UserAccoutContext);

    const model: Farm = useContext(FarmContext);
    const {onReward} = useReward();


    return (<StakeButton
        disabled={model.earning.eq(new BigNumber(0)) || model.isPause ||  ethAmout.eq(0)}
        text="Redeem"
        size="sm"
        onClick={onReward}
    />);
};


export const StakeButton: React.FC<ButtonProps> = ({
                                                       children,
                                                       disabled,
                                                       href,
                                                       onClick,
                                                       size,
                                                       text,
                                                       to,
                                                       variant,
                                                   }) => {
    const {color, spacing} = useContext(ThemeContext);

    let buttonColor: string;
    switch (variant) {
        case 'secondary':
            buttonColor = color.white;
            break;
        case 'default':
        default:
            buttonColor = color.white
    }

    let boxShadow: string;
    let buttonSize: number;
    let buttonPadding: number;
    let fontSize: number;
    return (<StyleStakeButton
        boxShadow={boxShadow}
        color={buttonColor}
        disabled={disabled}
        fontSize={fontSize}
        onClick={(e) => onClick(e)}

        padding={buttonPadding}
        size={buttonSize}
    >{text}</StyleStakeButton>);
};


const StyleStakeButton = styled.button<StyledButtonProps>`
  align-items: center;
  
  background-color: ${props => !props.disabled ? '#1C2F62' : '#0F1C3F'};
  border-radius: 5px;
  
  color: ${props => !props.disabled ? 'rgba(170, 184, 223, 1)' : 'rgba(118, 136, 183, 1)'};
  cursor: pointer;
  display: flex;
  font-size: 12px;
  font-weight: 700;
  border:1px solid rgba(32, 46, 83, 1);
  height: ${props => props.size}px;
  justify-content: center;
  outline: none;
  padding: 12px 0;
  pointer-events: ${props => !props.disabled ? undefined : 'none'};
  width: 100%;
  &:hover {
    // background-color: ${props => props.theme.color.grey[100]};
  }
`;
